import React from 'react';
import Validator from 'validator';
import { Callout, Button, FormGroup, InputGroup, Intent } from "@blueprintjs/core";

import { ActivitiesSelect } from "./Activities";
import { CountriesSelect } from "./Countries";

import Auth from '../../services/Auth';

class SignUpPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastname: '',
            firstname: '',
            email: '',
            password: '',
            repassword: '',
            company: '',
            activity: '',
            country: '',
            submiting: false
        };
    }

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState((prev) => {
            const newState = {
                ...prev,
                [name]: value
            }
            if (newState.password && newState.repassword) {
                if (newState.password === newState.repassword)
                    newState.errorPasswordMatch = false;
                else
                    newState.errorPasswordMatch = true;
            }
            if (newState.email)
                newState.errorEmailFormat = !Validator.isEmail(newState.email)
            return (newState);
        })
    }

    handleSelectChange = (name, value) => (
        this.setState({
            [name]: value
        })
    )

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ submiting: true, submitError: null });
        Auth.createAccountWithEmailAndPassword(this.state)
            .then(() => {
                this.setState({ submiting: false })
                this.openSignUpSuccessPanel();
            })
            .catch((e) => {
                const { code } = e;

                switch (code) {
                    case 'auth/email-already-in-use':
                        this.setState({ submitError: 'Cette adresse mail est déjà utilisée', submiting: false });
                        break;
                    case 'auth/invalid-email':
                        this.setState({ submitError: 'L\'adresse mail renseignée n\'est pas valide', submiting: false });
                        break;
                    default:
                        this.setState({ submitError: e.message, submiting: false });
                        return;
                }
            })
    }

    render() {
        const { errorPasswordMatch, errorEmailFormat, lastname, firstname, email, password, repassword, company, activity, country } = this.state;
        const isEnabled = lastname.length > 0 &&
            firstname.length > 0 &&
            email.length > 0 &&
            password.length > 5 &&
            repassword.length > 0 &&
            company.length > 0 &&
            activity.length > 0 &&
            country.length > 0 &&
            !errorPasswordMatch &&
            !errorEmailFormat;
        const intentPasswordLengthInputs = (password.length <= 0) ? Intent.NONE : (password.length > 5) ? Intent.SUCCESS : Intent.DANGER;
        const intentPasswordInputs = (errorPasswordMatch) ? Intent.DANGER : (errorPasswordMatch === false) ? Intent.SUCCESS : Intent.NONE;
        const intentEmailInput = (errorEmailFormat) ? Intent.DANGER : (errorEmailFormat === false) ? Intent.SUCCESS : Intent.NONE;

        return (
            <form onSubmit={this.handleSubmit}>
                {this.state.submitError != null &&
                    <Callout
                        title="Oups..."
                        intent={Intent.DANGER}>
                        {this.state.submitError}
                        {/* <br />
                        <span className="bp3-text-small bp3-text-muted">{this.state.submitError}</span> */}
                    </Callout>
                }
                <FormGroup labelFor="lastname">
                    <InputGroup large={true} leftIcon="id-number" placeholder="Name" id="lastname" name="lastname" onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup labelFor="firstname">
                    <InputGroup large={true} leftIcon="id-number" placeholder="Surname" id="firstname" name="firstname" onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup
                    labelFor="email"
                    intent={intentEmailInput}
                    helperText={this.state.errorEmailFormat && 'Please indicate valid email address'}>
                    <InputGroup
                        large={true}
                        intent={intentEmailInput}
                        leftIcon="envelope"
                        placeholder="Email"
                        id="email"
                        name="email"
                        onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup
                    labelFor="password"
                    intent={intentPasswordLengthInputs}
                    helperText={(password.length > 0 && password.length < 6) && 'Your password must be at least 6 characters long'}
                >
                    <InputGroup
                        large={true}
                        type='password'
                        leftIcon="lock"
                        intent={intentPasswordLengthInputs}
                        placeholder="Password"
                        id="password"
                        name="password"
                        onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup
                    intent={intentPasswordInputs}
                    helperText={this.state.errorPasswordMatch && 'Passwords do not match'}
                    labelFor="repassword">
                    <InputGroup
                        large={true}
                        type='password'
                        leftIcon="lock"
                        intent={intentPasswordInputs}
                        placeholder="Repeat password"
                        id="repassword"
                        name="repassword"
                        onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup labelFor="company">
                    <InputGroup large={true} leftIcon="office" placeholder="Name of your company" id="company" name="company" onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <ActivitiesSelect onItemSelect={(value) => this.handleSelectChange('activity', value)} />
                </FormGroup>
                <FormGroup>
                    <CountriesSelect onItemSelect={(value) => this.handleSelectChange('country', value)} />
                </FormGroup>
                <Button
                    type="submit"
                    text="Create account"
                    fill={true}
                    intent={Intent.SUCCESS}
                    disabled={!isEnabled}
                    loading={this.state.submiting} />
            </form>
        );
    }

    openSignUpSuccessPanel = () => {
        const panelNumber = this.props.panelNumber + 1;
        const successPanel = SignUpSuccessPanel;
        const goToLogin = () => {
            setTimeout(() => {
                this.props.closePanel();
            }, 400);
        }

        this.props.openPanel({
            component: successPanel,
            props: {
                panelNumber,
                goToLogin
            },
            title: 'Account created !'
        })
    }
}

class SignUpSuccessPanel extends React.Component {
    handleGoToLogin = () => {
        this.props.closePanel();
        this.props.goToLogin();
    }

    render() {
        return (
            <Callout
                intent={Intent.SUCCESS}
                title="Congratulation !">
                Your account has been created!
                <br />
                    An email has been sent to you to verify it.
                <div style={{ marginTop: '15px' }}>

                    <Button text="Connect" rightIcon="arrow-right" onClick={this.handleGoToLogin} />
                </div>
            </Callout>
        )
    }
}

export default SignUpPanel;